export const GET_LISTBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    listBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      text {
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                sys {
                  id
                }
                slug
                content {
                  __typename
                }
              }
            }
          }
        }
      }
      contentTypes
      categories
      name
      numberOfItems
      pagination
      listStyle
      minimalDesign
      newsTypeFilter
      eventTypeFilter
      reportTypeFilter
      eventListType
      eventFormatFilter
      fundingPageFilter
      yearFilter
      sortBy
      linkOnList {
        linkText
        globalLinkItem
        reference {
          ...on Page {
            content {
              __typename
            }
            slug
          }
          ...on FileBlock
          {
            imageVaultFile
          }
        }
        url
      }
      linkPlacement
      manualPostsCollection {
        items {
          __typename
          sys {
            id
            firstPublishedAt
            publishedAt
          }
          slug
          teaserTitle
          ivTeaserImage
          teaserText
          teaserLinkText
          content {
            __typename
            ... on Landingpage {
              heading
              preamble
            }
            ... on Standardpage {
              heading
              preamble
            }
            ... on Insurancepage {
              heading
              preamble
            }
            ... on InsuranceClaimPage {
              heading
              preamble
            }
            ... on Eventpage {
              heading
              preamble
              publishDate
              startDate
              endDate
              eventCategory
              eventFormat
            }
            ... on Newspage {
              heading
              publishDate
              hidePublishDate
              preamble
              newsType
            }
            ... on Reportpage {
              heading
              reportType
              publishDate
              preamble
            }
          }
        }
      }
    }
  }
`;
